import { render, staticRenderFns } from "./studentMatingDetail.vue?vue&type=template&id=2503de27&scoped=true&"
import script from "./studentMatingDetail.vue?vue&type=script&lang=js&"
export * from "./studentMatingDetail.vue?vue&type=script&lang=js&"
import style0 from "./studentMatingDetail.vue?vue&type=style&index=0&id=2503de27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2503de27",
  null
  
)

export default component.exports